<template lang="html">
  <section>
    <div
      class="keys-container"
      v-for="sortKey in fieldsToSort"
      :key="sortKey.id"
    >
      <search-box
        class="sort-field-search"
        ref="crmSortSearch"
        :id="`sort-search-${sortKey.id}`"
        :box-type="'deEditModal'"
        :has-icon="true"
        :has-des="true"
        :list="fields"
        :value="sortKey.key"
        :is-first-input="!sortKey.key"
        @on-search-box-item-selected="onSortKeySelected"
      />

      <b-form-select
        v-model="sortKey.sortDir"
        :options="sortDirections"
        :id="sortKey.id"
        @change="onSortDirChange"
        size="sm"
      ></b-form-select>

      <svg
        class="m-close-selection-icon"
        tabindex="0"
        @keydown.enter.stop="deleteKey(sortKey.id)"
        @click="deleteKey(sortKey.id)"
      >
        <use
          xlink:href="@/assets/icons/utility-sprite/svg/symbols.svg#close"
        ></use>
      </svg>
    </div>
    <div>
      <button class="link-action" @click="addSortKey">
        {{ $t("add") }}
      </button>
    </div>
  </section>
</template>

<script lang="js">
  import { v4 as uuidv4 } from "uuid";
  import { mapState } from "vuex";
  import SearchBox from "@/components/SearchBox";

  export default  {
    name: "sort-field",
    components: {
      SearchBox
    },
    props: {
      fields: {
        type: Array
      },
      initialSort: {
        type: Array
      }
    },
    computed: {
      ...mapState({
        messages: "messages"
      }),
      sortDirections() {
        return [
          {
            text: this.getMessageText(this.messages.ASCENDING),
            value: {
              text: this.getMessageText(this.messages.ASCENDING),
              value: "ASC"
            }
          },
          {
            text: this.getMessageText(this.messages.DESCENDING),
            value: {
              text: this.getMessageText(this.messages.DESCENDING),
              value: "DESC"
            }
          }
        ];
      }
    },
    mounted () {},
    data () {
      return {
        fieldsToSort: this.initialSort
      }
    },
    methods: {
      onSortKeySelected(val) {
        let sortKeyId = val.searchBoxId.replace("sort-search-", "");
        this.fieldsToSort.forEach(field => {
          if (field.id === sortKeyId) {
            if (val.name) {
              field.key = {
                name: val.name,
                label: val.label,
                type: val.type
              };
            } else {
              field.key = null;
            }
          }
        });
        this.triggerUpdate();
      },
      addSortKey() {
        let sortKey = {
          id: uuidv4(),
          key: null,
          sortDir: null
        };
        this.fieldsToSort.push(sortKey);
        this.triggerUpdate();
      },
      deleteKey(sortKeyId) {
        this.fieldsToSort = this.fieldsToSort.filter(field => {
          return field.id !== sortKeyId;
        });
        this.triggerUpdate();
      },
      onSortDirChange() {
        this.triggerUpdate();
      },
      triggerUpdate() {
        this.$emit("on-sort-fields-change", this.fieldsToSort);
      }
    }
  }
</script>

<style scoped lang="scss">
  .keys-container {
    display: flex;
    align-items: center;
    margin-bottom: 1rem;
  }

  .keys-container .m-text-input__label {
    display: none;
  }

  .keys-container .sort-field-search {
    flex-basis: 70%;
  }

  .m-close-selection-icon {
    margin-left: 0.5rem;
    width: 2rem;
    height: 2rem;
    fill: #706e6b;
    cursor: pointer;
    padding: 0.45rem;
  }
</style>
